var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenArrowSlant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83398 3.6665C5.83398 3.39036 6.05784 3.1665 6.33398 3.1665H12.334C12.6101 3.1665 12.834 3.39036 12.834 3.6665V9.6665C12.834 9.94265 12.6101 10.1665 12.334 10.1665C12.0578 10.1665 11.834 9.94265 11.834 9.6665V4.1665H6.33398C6.05784 4.1665 5.83398 3.94265 5.83398 3.6665Z",
    fill: "#103C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6865 3.31295C12.8817 3.50821 12.8817 3.82479 12.6865 4.02006L4.20121 12.5054C4.00595 12.7006 3.68937 12.7006 3.4941 12.5054C3.29884 12.3101 3.29884 11.9935 3.4941 11.7983L11.9794 3.31295C12.1746 3.11769 12.4912 3.11769 12.6865 3.31295Z",
    fill: "#103C1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowSlant);
export default __webpack_public_path__ + "static/media/green-arrow-slant.f7a33de83723d135d51bb1f4e24b1722.svg";
export { ForwardRef as ReactComponent };